import { render } from "./sv-svg-icon.vue?vue&type=template&id=184e90d5&scoped=true&ts=true"
import script from "./sv-svg-icon?vue&type=script&lang=ts&external"
export * from "./sv-svg-icon?vue&type=script&lang=ts&external"

import "./sv-svg-icon.scss?vue&type=style&index=0&id=184e90d5&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-184e90d5"]])

export default __exports__